import * as _helperValidatorIdentifier3 from "@babel/helper-validator-identifier";
var _helperValidatorIdentifier2 = "default" in _helperValidatorIdentifier3 ? _helperValidatorIdentifier3.default : _helperValidatorIdentifier3;
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isValidIdentifier;
  var _helperValidatorIdentifier = _helperValidatorIdentifier2;
  function isValidIdentifier(name, reserved = true) {
    if (typeof name !== "string") return false;
    if (reserved) {
      if ((0, _helperValidatorIdentifier.isKeyword)(name) || (0, _helperValidatorIdentifier.isStrictReservedWord)(name, true)) {
        return false;
      }
    }
    return (0, _helperValidatorIdentifier.isIdentifierName)(name);
  }

  //# sourceMappingURL=isValidIdentifier.js.map
  return exports;
}